import React, { createContext, useState, useContext, useEffect } from 'react';
import { AuthService } from '../services/APIService';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectIsAdmin,
  selectCurrentUser,
  selectIsAuthenticated,
  logout as reduxLogout,
  syncFromStorage,
} from '../data/authSlice';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();

  // Single source of truth: Redux state
  const user = useSelector(selectCurrentUser);
  const isAdmin = useSelector(selectIsAdmin);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // On mount, fix any inconsistent state (token without user or vice versa)
    const token = localStorage.getItem('token');
    const storedUser = AuthService.getCurrentUser();
    if (token && !storedUser) {
      dispatch(reduxLogout());
    }
    setLoading(false);
  }, [dispatch]);

  const login = async (credentials) => {
    try {
      const response = await AuthService.login(credentials);
      await new Promise(resolve => setTimeout(resolve, 50));
      dispatch(syncFromStorage());
      return response;
    } catch (error) {
      throw error;
    }
  };

  const register = async (userData) => {
    try {
      return await AuthService.register(userData);
    } catch (error) {
      throw error;
    }
  };

  const logout = () => {
    dispatch(reduxLogout());
  };

  const value = {
    user,
    isAuthenticated,
    isAdmin,
    loading,
    login,
    register,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};

export default AuthContext;
